var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlant = function SvgPlant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 37,
    viewBox: "0 0 60 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6387 8.28046C25.4205 8.28047 29.1387 12.4471 30.6387 17.2805C27.6387 18.6138 20.2387 20.8805 14.6387 19.2805C9.03867 17.6805 2.63867 13.6138 0.138672 11.7805C4.13867 9.78044 9.63867 8.28045 16.6387 8.28046Z",
    fill: "#0C7064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6387 8.28046C25.4205 8.28047 29.1387 12.4471 30.6387 17.2805C27.6387 18.6138 20.2387 20.8805 14.6387 19.2805C9.03867 17.6805 2.63867 13.6138 0.138672 11.7805C4.13867 9.78044 9.63867 8.28045 16.6387 8.28046Z",
    fill: "url(#plant_paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4367 4.97409C32.7206 6.04645 30.5571 12.4067 30.439 17.4661C33.6895 17.9263 41.4274 18.0783 46.3746 15.0049C51.3217 11.9316 56.2368 8.22868 58.1387 5.78044C56.0774 7.06101 51.1387 3.78044 41.4367 4.97409Z",
    fill: "#0C7064"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4367 4.97409C32.7206 6.04645 30.5571 12.4067 30.439 17.4661C33.6895 17.9263 41.4274 18.0783 46.3746 15.0049C51.3217 11.9316 56.2368 8.22868 58.1387 5.78044C56.0774 7.06101 51.1387 3.78044 41.4367 4.97409Z",
    fill: "url(#plant_paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1387 17.2805C31.472 19.9471 35.8155 31.3729 33.1387 36.2805",
    stroke: "#0C7064",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "plant_paint0_linear",
    x1: 15.6387,
    y1: 0.780442,
    x2: 15.6387,
    y2: 19.2804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DF95",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5DF95",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plant_paint1_linear",
    x1: 43.6387,
    y1: -4.21956,
    x2: 45.1387,
    y2: 22.7804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DF95",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5DF95",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plant.859919ec.svg";
export { ForwardRef as ReactComponent };